// extracted by mini-css-extract-plugin
module.exports = {"list":"providers-view_list__2OBvl"};